// Build proxied Skysight wind/terrain tile templates. Mirrors lib/overlays/urls.js:
// in production REACT_APP_API_BASE is empty and a Vercel rewrite forwards /api/* to
// the Worker; in dev it is the Worker origin (e.g. http://localhost:8787).
const API_BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');

// Wind/scalar composite raster, proxied. param = uv_{height} | uv_10 | blwind |
// bltopwind | wblmaxmin | ridge. The dataset depends on the model (verified
// live 2026-06-11): SkySight model -> cf.skysight.io/composite-ss, ICON ->
// cf.skysight.io/composite (hourly, maxzoom 7, no uv-120-ladder/no wblmaxmin).
export const windTileTemplate = ({ base = API_BASE, date, time, param, model }) =>
  `${base}/api/forecast/composite/${model === 'ICON' ? 'icon' : 'ss'}/${date}/${time}/${param}/{z}/{x}/{y}.webp`;

// Terrain-RGB DEM (maps.skysight.io/terrain), proxied — for wind terrain masking.
export const terrainTileTemplate = (base = API_BASE) =>
  `${base}/api/forecast/terrain/{z}/{x}/{y}.webp`;
